import BaseComponent from "../BaseComponent";
import ToggleInput from "components/Properties/InputComponents/ToggleInput";
import {NumberSliderInput} from "components/Properties/InputComponents/NumberInput";
import DropDownInput from "components/Properties/InputComponents/DropDownInput";

const AudioComponent = ({
  selectedObject,
  inputOnChange,
  checkboxOnChange,
  dropdownOnChange,
  dropdownOpened,
  setDropdownOpened,
  // isAudioPlaying,
  // playPreviewAudio,
  // stopPreviewAudio,
}) => {
  const hasAudio = selectedObject.userData.hasAudio || false;
  const audioInfo = selectedObject.userData.audioInfo;

  if (selectedObject.userData.type === "audio" || hasAudio) {
    return (
      <BaseComponent title="Audio" foldable={true}>
        <NumberSliderInput name="Volume" value={audioInfo.volume} min={0} max={100} step={1} inputOnChange={inputOnChange} />
        <NumberSliderInput name="PlaybackRate" value={audioInfo.playbackRate} min={0.1} max={10} step={0.1} inputOnChange={inputOnChange} />
        <NumberSliderInput
          name="Offset"
          value={audioInfo.offset.value}
          min={0}
          max={audioInfo.duration.default}
          checkboxOnChange={checkboxOnChange}
          inputOnChange={inputOnChange}
        />
        <NumberSliderInput
          name="Duration"
          min={0}
          max={audioInfo.duration.default}
          value={audioInfo.duration.value || 0}
          inputOnChange={inputOnChange}
        />
        <ToggleInput name="AudioAutoplay" checked={audioInfo.autoplay} checkboxOnChange={checkboxOnChange} />
        <ToggleInput name="Positional" checked={audioInfo.positional.isActive} checkboxOnChange={checkboxOnChange} />
        {audioInfo.positional.isActive && (
          <>
            <DropDownInput
              name="Distance Model"
              value={audioInfo.positional.distanceModel}
              selectedObject={selectedObject}
              array={["linear", "inverse", "exponential"]}
              dropdownOnChange={dropdownOnChange}
              dropdownOpened={dropdownOpened}
              setDropdownOpened={setDropdownOpened}
              depth={1}
            />
            <NumberSliderInput
              name="Ref Distance"
              value={audioInfo.positional.refDistance}
              min={0}
              max={100}
              step={1}
              inputOnChange={inputOnChange}
              depth={1}
            />
            {audioInfo.positional.distanceModel === "linear" && (
              <NumberSliderInput
                name="Max Distance"
                value={audioInfo.positional.maxDistance}
                min={0}
                max={100}
                step={1}
                inputOnChange={inputOnChange}
                depth={1}
              />
            )}
            <NumberSliderInput
              name="Rolloff Factor"
              value={audioInfo.positional.rolloffFactor}
              min={0}
              max={100}
              step={1}
              inputOnChange={inputOnChange}
              depth={1}
            />
            <ToggleInput
              name="Directional"
              checked={audioInfo.positional.directionalCone.isActive}
              checkboxOnChange={checkboxOnChange}
              depth={1}
              hasChildren={true}
            />
            {audioInfo.positional.directionalCone.isActive && (
              <>
                <NumberSliderInput
                  name="InnerAngle"
                  value={audioInfo.positional.directionalCone.coneInnerAngle}
                  min={0}
                  max={360}
                  step={1}
                  inputOnChange={inputOnChange}
                  depth={2}
                />
                <NumberSliderInput
                  name="OuterAngle"
                  value={audioInfo.positional.directionalCone.coneOuterAngle}
                  min={0}
                  max={360}
                  step={1}
                  inputOnChange={inputOnChange}
                  depth={2}
                />
                <NumberSliderInput
                  name="OuterGain"
                  value={audioInfo.positional.directionalCone.coneOuterGain}
                  min={0}
                  max={1}
                  step={0.01}
                  inputOnChange={inputOnChange}
                  depth={2}
                />
              </>
            )}
          </>
        )}
        <ToggleInput name="Loop" checked={audioInfo.loop.isActive} checkboxOnChange={checkboxOnChange} />
        {audioInfo.loop.isActive && (
          <>
            <NumberSliderInput
              name="Loop Start"
              value={audioInfo.loop.loopStart.value}
              min={0}
              max={audioInfo.duration.default}
              step={0.1}
              inputOnChange={inputOnChange}
              depth={1}
            />
            <NumberSliderInput
              name="Loop End"
              value={audioInfo.loop.loopEnd.value}
              min={0}
              max={audioInfo.duration.default}
              step={0.1}
              inputOnChange={inputOnChange}
              depth={1}
            />
          </>
        )}
      </BaseComponent>
    );
  } else {
    return null;
  }
};

export default AudioComponent;
